import React, { useContext, useEffect, useState } from "react";
import PedidosYaStyle from "../../../../assets/css/components/admin/plugins/PedidosYaStyle";
import { BiHide, BiShow } from "react-icons/bi";
import { accVtex } from "../../../../hooks/api/vtex";
import { GlobalContext } from "../../../../contexts/GlobalContext";
import ListOfProductsToSetParams from "../../../../assets/css/components/admin/marketplace-to-marketplace/products/ListOfProductsToSetParams";
import Select from "react-select";
import handleAxiosError from "../../update-and-publish/functions/handleAxiosError";
import { keyAccessToken, keyUserId } from "../../../../assets/js/SessionStorageNames";
import axios from "axios";

export default function VtexCredentials({
  username,
  loading,
  setLoading,
  modalNewCredential,
  setModalNewCredential,
  listUsers,
}) {
  const globalContext = useContext(GlobalContext);
  const [showPass, setShowPass] = useState(false);
  const [axiosCancelTokenSource] = useState(axios.CancelToken.source());
  const [tarifas, setTarifas] = useState([]);
  const toggleShowPassword = (e) => {
    setShowPass(!showPass);
  };

  const [accVtexData, setAccVtexData] = useState({
    username: "",
    apiKey: "",
    apiToken: "",
    odooPricelist: "",
  });

  const [getAccVtexData, setGetAccVtexData] = useState({
    username: "",
    apiKey: "",
    apiToken: "",
    odooPricelist: "",
  });
  const [originalAccData, setOriginalAccData] = useState({
    username: "",
    odooPricelist: "",
  });

  const handleNewAcc = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setAccVtexData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleGetAccVtexData = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setGetAccVtexData((prevData) => ({
      ...prevData,
      [name]: value || "",
    }));
  };

  const buildPayload = (data) => {
    return Object.entries(data).reduce((acc, [key, value]) => {
      if (value === null || value === undefined) return acc;
      if (typeof value === "string") {
        const normalizedValue = value.trim();
        if (!normalizedValue) return acc;
        acc[key] = normalizedValue;
        return acc;
      }
      acc[key] = value;
      return acc;
    }, {});
  };

  const buildUpdatePayload = (currentData, originalData) => {
    const normalizedCurrent = {
      username: (currentData.username || "").trim(),
      apiKey: (currentData.apiKey || "").trim(),
      apiToken: (currentData.apiToken || "").trim(),
      odooPricelist: (currentData.odooPricelist || "").trim(),
    };

    const normalizedOriginal = {
      odooPricelist: (originalData.odooPricelist || "").trim(),
    };

    const payload = { username: normalizedCurrent.username };

    if (normalizedCurrent.apiKey) payload.apiKey = normalizedCurrent.apiKey;
    if (normalizedCurrent.apiToken) payload.apiToken = normalizedCurrent.apiToken;

    if (
      normalizedCurrent.odooPricelist &&
      normalizedCurrent.odooPricelist !== normalizedOriginal.odooPricelist
    ) {
      payload.odooPricelist = normalizedCurrent.odooPricelist;
    }

    return payload;
  };

  const validateCredentialsData = async (data, isUpdate) => {
    const errors = [];

    if (!isUpdate) {
      if (!data.username) errors.push("username es obligatorio.");
      if (!data.apiKey) errors.push("apiKey es obligatorio.");
      if (!data.apiToken) errors.push("apiToken es obligatorio.");
      if (!data.odooPricelist) errors.push("odooPricelist es obligatorio.");
    }

    if (data.apiKey && data.apiKey.length < 18) {
      errors.push("El campo apiKey debe tener al menos 18 caracteres.");
    }

    if (data.apiToken && data.apiToken.length < 85) {
      errors.push("El campo apiToken debe tener al menos 85 caracteres.");
    }

    if (data.apiKey && data.apiToken && data.apiKey === data.apiToken) {
      errors.push("apiKey y apiToken no pueden ser iguales.");
    }

    if (errors.length > 0) {
      await globalContext.showModalWithMsg(errors.join(" "));
      return false;
    }

    return true;
  };

  const handleSubmitData = async (save) => {
    const entId = await globalContext.currentEnterpriseId;
    const formData = save ? getAccVtexData : accVtexData;
    const payload = save
      ? buildUpdatePayload(formData, originalAccData)
      : buildPayload(formData);

    if (!(await validateCredentialsData(payload, save))) return;

    const hasUpdateChanges =
      !!payload.apiKey ||
      !!payload.apiToken ||
      !!payload.odooPricelist;

    if (save && !hasUpdateChanges) {
      await globalContext.showModalWithMsg("No hay cambios para guardar.");
      return;
    }

    setLoading(true);
    try {
      const resp = await accVtex("POST", entId, payload);
      const successMessage = save
        ? `Has actualizado la cuenta de ${username} correctamente.`
        : "Has creado una cuenta correctamente.";
      await globalContext.showModalWithMsg(successMessage);
      if (save) {
        const normalizedOdooPricelist = (getAccVtexData.odooPricelist || "").trim();

        setOriginalAccData((prev) => ({
          ...prev,
          odooPricelist: normalizedOdooPricelist,
        }));

        setGetAccVtexData((prev) => ({
          ...prev,
          apiKey: "",
          apiToken: "",
          odooPricelist: normalizedOdooPricelist,
        }));
      } else {
        setModalNewCredential(false);
      }
    } catch (err) {
      console.error("Error al guardar credenciales de Vtex", err);
      const backendMessage =
        err?.response?.data?.message ||
        err?.message ||
        `Ha ocurrido un error al actualizar la cuenta de ${username}.`;
      await globalContext.showModalWithMsg(backendMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (listUsers) {
      const isUser = listUsers.filter((user) => user.username === username);
      if (isUser.length > 0) {
        setGetAccVtexData({
          username: isUser[0].username || "",
          apiKey: (isUser[0].apiKey || "").trim(),
          apiToken: (isUser[0].apiToken || isUser[0].token || "").trim(),
          odooPricelist: isUser[0].odooPricelist || "",
        });
        setOriginalAccData({
          username: isUser[0].username || "",
          odooPricelist: isUser[0].odooPricelist || "",
        });
      }
    }
    getPriceList();
  }, [modalNewCredential, listUsers, username]);

  async function getPriceList() {
    const entId = await globalContext.currentEnterpriseId;
    const url = `${process.env.REACT_APP_BACKEND_URL}/v1/odoo-pricelist/${entId}`;
    if (entId)
      await axios
        .get(url, {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        })
        .then((resp) => {
          const data = resp.data.data;
          setTarifas(data.priceLists);
        })
        .catch((err) => {
          handleAxiosError(
            err,
            "Disculpe, no se pudo cargar la lista de tarifas."
          );
        });
  }

  const ui = {
    pageWrap: {
      marginTop: 10,
      padding: "8px 0 24px",
      fontFamily: "sans-serif",
    },
    card: {
      marginTop: 18,
      borderRadius: 16,
      boxShadow: "0 10px 30px rgba(26, 33, 52, 0.08)",
      border: "1px solid #e7eaf3",
      overflow: "hidden",
      background: "#ffffff",
    },
    header: {
      background: "#1465BB",
      borderBottom: "1px solid #e7eaf3",
      padding: "14px 18px",
    },
    body: {
      padding: "8px 0 16px",
    },
    sectionTitle: {
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontSize: "11px",
      fontWeight: 700,
      color: "#5b6780",
      marginBottom: 6,
      textAlign: "left",
    },
    helperText: {
      marginTop: 6,
      marginBottom: 0,
      fontSize: "11px",
      lineHeight: 1.4,
      color: "#5b6780",
      textAlign: "left",
    },
    fieldWrap: {
      width: "70%",
      margin: "0 auto",
    },
    row: {
      width: "70%",
      margin: "0 auto",
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 12,
      alignItems: "start",
    },
    rowFull: {
      width: "70%",
      margin: "0 auto",
    },
    input: {
      borderRadius: 10,
      border: "1px solid #b5c0d4",
      background: "#f8faff",
      minHeight: 42,
    },
    select: {
      borderRadius: 10,
      border: "1px solid #b5c0d4",
      background: "#f8faff",
      minHeight: 42,
      width: "100%",
      padding: "0 12px",
    }, 
    primaryBtn: {
      width: "100%",
      textAlign: "center",
      borderRadius: "10px !important",
      minHeight: 50,
      background: "#1465BB",
      color: "#ffffff",
      boxShadow: "0 8px 20px rgba(217, 250, 99, 0.35)",
      fontWeight: 600,
      letterSpacing: "0.01em",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modalOverlay: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100vw",
      height: "100vh",
      position: "absolute",
      top: 0,
      left: 0,
      backgroundColor: "rgba(18, 23, 37, 0.42)",
      backdropFilter: "blur(2px)",
    },
  };

  const tarifaOptions = tarifas.map((val) => ({
    value: val.name,
    label: val.name,
  }));

  const getTarifaValue = (value) => {
    if (!value) return null;
    return (
      tarifaOptions.find((option) => option.value === value) || {
        value,
        label: value,
      }
    );
  };

  const handleTarifaChange = (option, isEditMode) => {
    const value = option?.value || "";
    const syntheticEvent = {
      target: {
        name: "odooPricelist",
        value,
      },
    };
    if (isEditMode) {
      handleGetAccVtexData(syntheticEvent);
      return;
    }
    handleNewAcc(syntheticEvent);
  };

  const selectSearchStyles = {
    container: (base) => ({
      ...base,
      width: "100%",
    }),
    control: (base, state) => ({
      ...base,
      width: "100%",
      borderRadius: 10,
      borderColor: state.isFocused ? "#142032" : "#b5c0d4",
      boxShadow: state.isFocused ? "0 0 0 1px #142032" : "none",
      minHeight: 42,
      backgroundColor: "#f8faff",
      "&:hover": {
        borderColor: "#142032",
      },
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 10px",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      minHeight: 42,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 30,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#142032"
        : state.isFocused
        ? "#f2f5fb"
        : "#fff",
      color: state.isSelected ? "#fff" : "#142032",
    }),
  };

  const selectSearchStylesSmallPlaceholder = {
    ...selectSearchStyles,
    placeholder: (base) => ({
      ...base,
      fontSize: ".8rem",
    }),
  };
  
  return (
    <div style={ui.pageWrap}>
      {!modalNewCredential ? (
        <>
          <PedidosYaStyle.ContForm style={ui.card}>
            <PedidosYaStyle.HeaderForm style={ui.header}>
              <PedidosYaStyle.Text size="14pt" fw="500" cl="#FFFFFF">
                Credenciales de <span style={{ fontWeight: "bold" }}>VTEX: {username}</span>
              </PedidosYaStyle.Text>
            </PedidosYaStyle.HeaderForm>

            <PedidosYaStyle.BodyForm style={ui.body} autoComplete="off">
              <form
                autoComplete="off"
                noValidate
                onSubmit={(e) => e.preventDefault()}
                style={{ display: "contents" }}
              >
              <div style={{ ...ui.row, marginTop: 20 }}>
                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="1">
                  <PedidosYaStyle.Text size="12pt" style={ui.sectionTitle}>
                    <strong>Username</strong>
                  </PedidosYaStyle.Text>
                  <PedidosYaStyle.Input
                    name="username"
                    value={getAccVtexData.username || ""}
                    placeholder="Username"
                    onChange={handleGetAccVtexData}
                    disabled={true}
                    autoComplete="off"
                    data-lpignore="true"
                    data-1p-ignore="true"
                    data-bwignore="true"
                    style={{ ...ui.input, backgroundColor: "#eef1f8" }}
                  ></PedidosYaStyle.Input>
                  <p style={ui.helperText}>
                    Identificador de la cuenta VTEX asociada. Campo sensible: no editar manualmente.
                  </p>
                </PedidosYaStyle.ContInputAndLabel>
                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="1">
                  <PedidosYaStyle.Text size="12pt" style={ui.sectionTitle}>
                    <strong>Tarifa</strong>
                  </PedidosYaStyle.Text>
                  <Select
                    classNamePrefix="vtex-tarifa-select"
                    isSearchable
                    name="odooPricelist"
                    inputProps={{
                      autoComplete: "off",
                      autoCorrect: "off",
                      autoCapitalize: "off",
                      spellCheck: false,
                      "data-lpignore": "true",
                      "data-1p-ignore": "true",
                    }}
                    value={getTarifaValue(getAccVtexData.odooPricelist)}
                    onChange={(option) => handleTarifaChange(option, true)}
                    options={tarifaOptions}
                    placeholder="Tarifa sin seleccionar"
                    noOptionsMessage={() => "Sin resultados"}
                    styles={selectSearchStyles}
                  />
                  <p style={ui.helperText}>
                    Define la lista de precios usada para sincronizar productos.
                  </p>
                
                </PedidosYaStyle.ContInputAndLabel>
              </div>
              <div style={{ ...ui.row, marginTop: 14 }}>
                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="1">
                  <PedidosYaStyle.Text size="12pt" style={ui.sectionTitle}>
                    <strong>Apikey</strong>
                  </PedidosYaStyle.Text>
                  <PedidosYaStyle.ContIconNadInputPass>
                    <PedidosYaStyle.Input
                      style={{ ...ui.input, width: "100%" }}
                      name="apiKey"
                      type={showPass ? "text" : "password"}
                      value={getAccVtexData.apiKey || ""}
                      disabled={loading}
                      placeholder="No tocar este campo"
                      autoComplete="new-password"
                      data-lpignore="true"
                      data-1p-ignore="true"
                      data-bwignore="true"
                      onChange={handleGetAccVtexData}
                    />
                    <PedidosYaStyle.BtnShowPass
                      onClick={(e) => toggleShowPassword(e)}
                    >
                      {showPass ? <BiHide /> : <BiShow />}
                    </PedidosYaStyle.BtnShowPass>
                  </PedidosYaStyle.ContIconNadInputPass>
                  <p style={ui.helperText}>
                    Llave privada de acceso a VTEX. Campo critico: cambiarlo puede romper integraciones.
                  </p>
                </PedidosYaStyle.ContInputAndLabel>
              </div>
              <PedidosYaStyle.ContInputAndLabel
                w="65%"
                colSpan="2"
                style={{ ...ui.rowFull, marginTop: 14 }}
              >
                <PedidosYaStyle.Text size="12pt" style={ui.sectionTitle}>
                  <strong>Apitoken</strong>
                </PedidosYaStyle.Text>
                <PedidosYaStyle.ContIconNadInputPass>
                  <PedidosYaStyle.Input
                    style={{ ...ui.input, width: "100%" }}
                    name="apiToken"
                    type={showPass ? "text" : "password"}
                    value={getAccVtexData.apiToken || ""}
                    disabled={loading}
                    placeholder="No tocar este campo"
                    autoComplete="new-password"
                    data-lpignore="true"
                    data-1p-ignore="true"
                    data-bwignore="true"
                    onChange={handleGetAccVtexData}
                  />
                  <PedidosYaStyle.BtnShowPass
                    onClick={(e) => toggleShowPassword(e)}
                  >
                    {showPass ? <BiHide /> : <BiShow />}
                  </PedidosYaStyle.BtnShowPass>
                </PedidosYaStyle.ContIconNadInputPass>
                <p style={ui.helperText}>
                  Token secreto para autenticar la API.
                </p>
              </PedidosYaStyle.ContInputAndLabel>
              <PedidosYaStyle.ContInputAndLabel
                w="50%"
                colSpan="2"
                style={{ ...ui.rowFull, marginTop: 22 }}
              >
                <PedidosYaStyle.ContInputButtonGroup marginBottom="5px">
                  <PedidosYaStyle.BtnSend
                    onClick={() => handleSubmitData(true)}
                    style={ui.primaryBtn}
                  >
                    {loading ? "Espere" : "Guardar Credencial"}
                  </PedidosYaStyle.BtnSend>
                </PedidosYaStyle.ContInputButtonGroup>
              </PedidosYaStyle.ContInputAndLabel>
              </form>
            </PedidosYaStyle.BodyForm>
          </PedidosYaStyle.ContForm>
        </>
      ) : (
        <div
          style={ui.modalOverlay}
        >
          <PedidosYaStyle.ContForm
            style={{
              position: "absolute",
              maxWidth: 700,
              margin: "auto",
              width: "100%",
              borderRadius: 16,
              boxShadow: "0 16px 36px rgba(13, 18, 32, 0.22)",
              border: "1px solid #e7eaf3",
              overflow: "hidden",
            }}
          >
            <ListOfProductsToSetParams.Close
              style={{
                position: "absolute",
                top: 14,
                right: 12,
                width: 34,
                height: 34,
                borderRadius: "50%",
                backgroundColor: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 8px 16px rgba(20, 32, 50, 0.22)",
                zIndex: 2,
              }}
              onClick={() => setModalNewCredential(false)}
            ></ListOfProductsToSetParams.Close>
            <PedidosYaStyle.HeaderForm style={ui.header}>
              <PedidosYaStyle.Text size="14pt" cl="#FFFFFF">
                Agregar nueva crendencial para <span style={{ fontWeight: "bold" }}>VTEX</span>
              </PedidosYaStyle.Text>
            </PedidosYaStyle.HeaderForm>

            <PedidosYaStyle.BodyForm style={ui.body} autoComplete="off">
              <form
                autoComplete="off"
                noValidate
                onSubmit={(e) => e.preventDefault()}
                style={{ display: "contents" }}
              >
              <div style={{ ...ui.row, marginTop: 20 }}>
                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="1">
                  <PedidosYaStyle.Text size="12pt" style={ui.sectionTitle}>
                    <strong>Username</strong>
                  </PedidosYaStyle.Text>
                  <PedidosYaStyle.Input
                    name="username"
                    value={accVtexData.username || ""}
                    placeholder="Username"
                    autoComplete="off"
                    data-lpignore="true"
                    data-1p-ignore="true"
                    data-bwignore="true"
                    onChange={handleNewAcc}
                    style={ui.input}
                  ></PedidosYaStyle.Input>
                  <p style={ui.helperText}>
                    Nombre unico para identificar esta cuenta VTEX dentro del panel.
                  </p>
                </PedidosYaStyle.ContInputAndLabel>
                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="1">
                  <PedidosYaStyle.Text size="12pt" style={ui.sectionTitle}>
                    <strong>Tarifa</strong>
                  </PedidosYaStyle.Text>
                  <Select
                    classNamePrefix="vtex-tarifa-select"
                    isSearchable
                    name="odooPricelist"
                    inputProps={{
                      autoComplete: "off",
                      autoCorrect: "off",
                      autoCapitalize: "off",
                      spellCheck: false,
                      "data-lpignore": "true",
                      "data-1p-ignore": "true",
                    }}
                    value={getTarifaValue(accVtexData.odooPricelist)}
                    onChange={(option) => handleTarifaChange(option, false)}
                    options={tarifaOptions}
                    placeholder="SELECCIONE UNA TARIFA"
                    noOptionsMessage={() => "Sin resultados"}
                    styles={selectSearchStylesSmallPlaceholder}
                  />
                  <p style={ui.helperText}>
                    Tarifa que se aplicara al publicar o actualizar precios desde Odoo.
                  </p>

                </PedidosYaStyle.ContInputAndLabel>
              </div>
              <div style={{ ...ui.row, marginTop: 14 }}>
                <PedidosYaStyle.ContInputAndLabel w="100%" colSpan="1">
                  <PedidosYaStyle.Text size="12pt" style={ui.sectionTitle}>
                    <strong>Apikey</strong>
                  </PedidosYaStyle.Text>
                  <PedidosYaStyle.ContIconNadInputPass>
                    <PedidosYaStyle.Input
                      style={{ ...ui.input, width: "100%" }}
                      name="apiKey"
                      type={showPass ? "text" : "password"}
                      value={accVtexData.apiKey || ""}
                      disabled={loading}
                      placeholder="Ingrese su apikey aqui"
                      autoComplete="new-password"
                      data-lpignore="true"
                      data-1p-ignore="true"
                      data-bwignore="true"
                      onChange={handleNewAcc}
                    />
                    <PedidosYaStyle.BtnShowPass
                      onClick={(e) => toggleShowPassword(e)}
                    >
                      {showPass ? <BiHide /> : <BiShow />}
                    </PedidosYaStyle.BtnShowPass>
                  </PedidosYaStyle.ContIconNadInputPass>
                  <p style={ui.helperText}>
                    Apikey de VTEX para autenticar llamadas. Compartirla o alterarla implica riesgo operativo.
                  </p>
                </PedidosYaStyle.ContInputAndLabel>
              </div>
              <PedidosYaStyle.ContInputAndLabel
                w="65%"
                colSpan="2"
                style={{ ...ui.rowFull, marginTop: 14 }}
              >
                <PedidosYaStyle.Text size="12pt" style={ui.sectionTitle}>
                  <strong>Apitoken</strong>
                </PedidosYaStyle.Text>
                <PedidosYaStyle.ContIconNadInputPass>
                  <PedidosYaStyle.Input
                    style={{ ...ui.input, width: "100%" }}
                    name="apiToken"
                    type={showPass ? "text" : "password"}
                    value={accVtexData.apiToken || ""}
                    disabled={loading}
                    placeholder="apiToken"
                    autoComplete="new-password"
                    data-lpignore="true"
                    data-1p-ignore="true"
                    data-bwignore="true"
                    onChange={handleNewAcc}
                  />
                  <PedidosYaStyle.BtnShowPass
                    onClick={(e) => toggleShowPassword(e)}
                  >
                    {showPass ? <BiHide /> : <BiShow />}
                  </PedidosYaStyle.BtnShowPass>
                </PedidosYaStyle.ContIconNadInputPass>
                <p style={ui.helperText}>
                  Token de seguridad complementario de la API VTEX.
                </p>
              </PedidosYaStyle.ContInputAndLabel>
              <PedidosYaStyle.ContInputAndLabel
                w="50%"
                colSpan="2"
                style={{ ...ui.rowFull, marginTop: 22 }}
              >
                <PedidosYaStyle.ContInputButtonGroup marginBottom="5px">
                  <PedidosYaStyle.BtnSend
                    onClick={() => handleSubmitData(false)}
                    style={ui.primaryBtn}
                  >
                    {loading ? "Espere" : "Guardar nueva Credencial"}
                  </PedidosYaStyle.BtnSend>
                </PedidosYaStyle.ContInputButtonGroup>
              </PedidosYaStyle.ContInputAndLabel>
              </form>

            </PedidosYaStyle.BodyForm>
          </PedidosYaStyle.ContForm>
        </div>
      )}
    </div>
  );
}
